// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".CloseButton-module-close-3Tp6R{text-align:center;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;user-select:none;z-index:9999}", ""]);
// Exports
exports.locals = {
	"close": "CloseButton-module-close-3Tp6R"
};
module.exports = exports;
